// blakfy-cookie/src/presets/youtube.js — YouTube embed preset (marketing category)

export default {
  name: "YouTube",
  category: "marketing",
  cookies: [],
  storage: [],
  scriptHosts: ["www.youtube.com", "youtube-nocookie.com"],
  onGrant: (state) => {},
  onRevoke: (state) => {},
};
